import { useState, useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { Select } from '@components/select';
import { Stack } from '@components/stack';

import { Stage } from '../Stages/Stage';

export const ApplicantList = observer(({ selectedApplication, job }) => {
  const [selected, setSelected] = useState(selectedApplication.jobStageId);

  const stage = job.jobStages.find((stage) => stage.id === selected);
  useEffect(() => {
    if (stage && stage.state !== 'loaded') {
      stage.loadWithoutFilters();
    }
    return () => {
      stage && stage.reset();
    };
  }, [stage]);

  if (!stage) return null;

  return (
    <Stack space={2}>
      <Select
        isClearable={false}
        isSearchable={false}
        defaultValue={stage.id}
        options={job.applicantJobStages}
        onChange={(stage) => setSelected(Number(stage))}
      />
      <Stage stage={stage} selectedId={selectedApplication.id} />
    </Stack>
  );
});
